import { Checkbox } from 'antd';
import classNames from 'classnames';

import { useMonitorSearchFiltersStyles } from './MonitorSearchFilters.styles';

export function StatusCheckboxList({ value, onChange, options, className }) {
  const { styles } = useMonitorSearchFiltersStyles();
  const selected = value || [];

  const toggle = optionValue => {
    const next = selected.includes(optionValue)
      ? selected.filter(v => v !== optionValue)
      : [...selected, optionValue];
    onChange(next);
  };

  return (
    <div className={classNames('StatusCheckboxList', className)}>
      {options.map(({ value: optionValue, label, title }) => (
        // eslint-disable-next-line jsx-a11y/label-has-associated-control
        <label
          key={optionValue}
          className={classNames(
            'StatusCheckboxList--Item',
            styles.statusCheckboxListItem
          )}
          title={title}
        >
          <Checkbox
            checked={selected.includes(optionValue)}
            onChange={() => toggle(optionValue)}
          />
          <span
            className={classNames(
              'StatusCheckboxList--Label',
              styles.statusCheckboxListLabel
            )}
          >
            {label}
          </span>
        </label>
      ))}
    </div>
  );
}
